export function useFriendsStoreLoader({ autoLoad } = { autoLoad: true }) {
  const { tournamentsEnabled } = useRuntimeConfig().public;
  const store = shallowRef<ReturnType<(typeof import('~/store/friends'))['useFriendsStore']> | null>(null);

  async function load(): Promise<typeof store.value> {
    if (!tournamentsEnabled) return null;

    const { useFriendsStore } = await import('~/store/friends');
    store.value = useFriendsStore();
    return store.value;
  }

  if (autoLoad) {
    load();
  }

  return { store, load };
}
